import React from "react";
import ReactDOM from "react-dom/client";
import Layout from "./src/components/Layout";
import "./src/styles/import.scss";

export const replaceHydrateFunction = () => {
  return (element: any, container: any) => {
    const root = ReactDOM.createRoot(container)
    root.render(element)
  }
}

export const wrapPageElement = ({ element }: any) => {
  return (
    <Layout>{element}</Layout>
  );
};
